import {useEffect} from "react";

import {config} from "@/config";
import {useWhiteLabelTheme} from "../useWhiteLabelTheme/useWhiteLabelTheme";

const {websiteId} = config;

export const usePageTitle = title => {
  const {themeConfig} = useWhiteLabelTheme();
  let brandName = websiteId == 3 ? "BiomarkerTracking" : websiteId == 2 ? "Edge" : "Forth";

  if (window.config.isWhiteLabelApp) {
    const appName = themeConfig?.appName || null;
    brandName = appName ? appName : "";
  }

  useEffect(() => {
    document.title = title && brandName ? title.concat(` | ${brandName}`) : title ? title : brandName ? brandName : "";
  }, [title, brandName]);
};
